module.exports = __webpack_public_path__ + "img/child-three.ead6d7d6.png";